<template>
  <div class="search-view">
    <div class="search-input-box">
      <div @click="inputfocus" class="search-input">
        <i class="icon search-icon"></i>
        <input id="searchInput" class="input_null" autofocus @input="search" v-model="searchVal" type="text" placeholder="股票代码/名称/简拼">
        <i @click="searchList = [];searchVal = ''" v-show="searchVal.length > 0" class="icon close-icon"></i>
        <div id="showinput" @click="inputfocus"></div>
      </div>
      <div :style="{'font-size': '16px'}" @click="cancel">取消</div>
    </div>
    <div id="hideinput" @click="inputBlur"></div>
    <!-- 无数据 -->
    <div class="search-notdata" v-if="searchList.length === 0 && searchVal.length > 0">
      <img v-if="!loading" src="../../assets/nodata.png" alt="" width="250px" height="153px">
      <p v-if="!loading">暂无匹配信息</p>
      <div v-if="loading" class="loading"></div>
    </div>
    <!-- 热搜模块 -->
    <div class="hot-search-content" v-show="searchVal.length === 0">
      <div class="hot-title">
        热搜榜
      </div>
      <div class="hot-itemlist">
        <div class="hot-item" v-for="item in hotSymbols" :key="item.Symbol" @click="goGegu(item)">
          <p style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{item.Name}}</p>
          <label>{{item.Symbol}}.{{item.Exchange.slice(0,2)}}</label>
        </div>
      </div>
    </div>
    <!-- 搜索内容块 -->
    <div class="searchval-content" v-if="searchList.length > 0">
      <div class="searchval-item" v-for="(item, index) in searchList" :key="index" @click="goGegu(item)">
        <div class="searchval-header">
          <!-- <p class="SZ">SZ</p> -->
          <img src="../../assets/hkicon.png" alt="" width="15px" height="13px" v-if="item.Exchange === 'HKEX'">
          <img src="../../assets/usicon.png" alt="" width="15px" height="13px" v-if="item.Exchange === 'US'">
          <label v-html="item.Name"></label>
        </div>
        <label v-html="item.Symbol" class="searchval-symbol"></label>
      </div>
      <div v-if="searchList.length < 15" class="no-result">没有更多了</div>
      <infinite-loading v-else ref="searchloading" @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
        <!-- <div slot="no-more">无更多数据</div> -->
        <div slot="no-more" class="no-result">没有更多了</div>
        <div slot="no-results" class="no-results">
          <!-- 无{{tabs[tabIndex].label}}数据 -->
        </div>
        <div slot="spinner" class="tab-spinner">正在加载...</div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import { request } from '@/api/request'
import debounce from 'lodash/debounce'
import {mapMutations} from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  data() {
    return {
      loading: true,
      searchVal: '',
      hotSymbols: [],
      searchList: [],
      pageNo: 0,
      intervalFlag: null
    }
  },
  async created() {
    this.hotSymbols = await request.get({
      url: request.apis.quote.hotSearchV3,
      params: {
        number: 15
      }
    })
    this.hotSymbols = this.hotSymbols.map(item => {
      item.code = item.Symbol
      return item
    })
  },
  mounted() {
    document.getElementById('showinput').click()
    window.onscroll = () => {
      if (window.scrollY > 100) {
        if (document.getElementById('hideinput')) document.getElementById('hideinput').click()
      }
    }
  },
  components: {
    InfiniteLoading
  },
  methods: {
    ...mapMutations({
      setTabIndex: 'common/setTabIndex'
    }),
    async infiniteHandler($state) {
      let canload = await this.getSearchData()
      if (canload) $state.loaded()
      else $state.complete()
    },
    async getSearchData() {
      let res = await request.get({
        url: request.apis.quote.queryStockSearch,
        params: {
          keyword: this.searchVal,
          types: 'stock',
          pageNo: this.pageNo++,
          pageSize: 15
        }
      })
      if (res.stock.length > 0 && this.searchVal.length > 0) {
        this.searchList = this.searchList.concat(res.stock.map(item => {
          console.log('zxcsadasdas', this.searchVal, item.Name.replace(this.searchVal, `<span class="searchred">${this.searchVal}</span>`))
          item.Name = item.Name.replace(this.searchVal, `<span class="searchred">${this.searchVal}</span>`)
          item.code = item.Symbol
          item.Symbol = item.Symbol.replace(this.searchVal, `<span class="searchred">${this.searchVal}</span>`)
          return item
        }))
        return true  
      } else return false
    },
    goGegu(item) {
      this.setTabIndex(0)
      request.post({
        url: request.apis.quote.hotSerchAdd,
        params: {
          market: item.Market,
          symbol: item.code
        }
      })
      this.$router.options.routes.filter(_ => _.name === 'Home')[0].meta.keepAlive = false
      this.$router.push({
        path: `/${item.Market}/${item.code}.html`,
      })
    },
    inputBlur() {
      // window.scroll(0, 0)
      document.getElementById('searchInput').blur()
    },
    inputfocus() {
      // window.scroll(0, 0)
      setTimeout(() => {
        document.getElementById('searchInput').focus()
      }, 100)
    },
    search: debounce(async function () {
      this.loading = true
      this.pageNo = 0
      if (this.searchVal.length === 0) {
        this.searchList = []
        return
      }

      // await this.infiniteHandler()
      let res = await request.get({
        url: request.apis.quote.queryStockSearch,
        params: {
          keyword: this.searchVal,
          types: 'stock',
          pageNo: this.pageNo++,
          pageSize: 15,
          markets: 'NASDAQ,HKSE,NYSE,AMEX,COMEX,FHSI,HKIDX'
        }
      })
      this.searchList = res.stock.map(item => {
        item.Name = item.Name.replace(this.searchVal, `<span class="searchred">${this.searchVal}</span>`)
        item.code = item.Symbol
        item.Symbol = item.Symbol.replace(this.searchVal, `<span class="searchred">${this.searchVal}</span>`)
        return item
      })
      this.loading = false
      if (this.$refs.searchloading) {
        this.$refs.searchloading.stateChanger.reset()
        this.infiniteHandler(this.$refs.searchloading.stateChanger)
      }
    }, 500),
    cancel() {
      // console.log('cancel')
      this.searchVal = ''
      this.$router.go(-1)
      // console.log('this.searchVal', this.searchVal)
    }
  }
}
</script>

<style lang="stylus">
.loading
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  border: 2px solid #999;
  border-bottom-color: transparent;
  -webkit-animation: loading 0.75s linear infinite;
  animation: loading 0.75s linear infinite;
  // 位置相关
  margin: 6px;
  vertical-align: middle
  
@-webkit-keyframes loading {
  0% { -webkit-transform: rotate(0deg); }
  50% { -webkit-transform: rotate(180deg); }
  100% { -webkit-transform: rotate(360deg); }
}
@keyframes loading {
  0% { -webkit-transform: rotate(0deg); }
  50% { -webkit-transform: rotate(180deg); }
  100% { -webkit-transform: rotate(360deg); }
}

.search-view
  width 100vw
  // height 100vh
  background #f5f5f5
  .search-notdata
    margin auto 
    text-align center
    padding-top 151px
    p
      color #999
      font-size 14px
  .searchval-content
    background #fff
    // padding-top 46px
    // height calc(100vh - 46px)
    // overflow scroll
    .no-result
      background #f5f5f5
      text-align center
      font-size 14px
      color #cdcdcd
      padding 15px 0
    .searchval-item
      margin 0 16px
      padding 6px 0 
      border-top 1px solid #edeff3
      &:first-child
        border-top none
    .searchval-header
      display flex
      align-items center
      label
        display block
        width 96%
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
      .searchred
        color #e9867a
    .searchval-symbol
      padding-left 15px
      font-size 12px
      color #666
      .searchred
        color #e9867a
  .hot-search-content
    background #fff
    // height calc(100vh - 46px)
    // padding-top 46px
    .hot-itemlist
      display flex
      flex-wrap wrap
      .hot-item
        width 33%
        text-align center
        padding 8px 0
        border-bottom 1px solid rgb(245, 245, 245)
        border-right 1px solid rgb(245, 245, 245)
        p
          font-size 15px
          color rgb(50, 50, 50)
          height 21px
          line-height 21px
        label
          font-size 13px
          color #999999
          line-height 18px
          height 18px
        &:nth-child(3n)
          border-right none
        &:nth-child(3n + 2)
          width calc(34% - 2px)
    .hot-title
      font-size 16px
      padding 15px 0 15px 16px
      color #333
      border-bottom 1px solid rgb(245, 245, 245)
      font-weight 600
  .search-input-box
    // position fixed
    display flex
    align-items center
    padding 8px 0
    background #fff
    top 0
    width 100%
    border-bottom 1px solid #f5f5f5
    // z-index 1
    .search-input
      position relative
      margin-left 20px
      margin-right 10px
      width 292px
      display flex
      background rgb(245, 245, 245)
      border-radius 15px
      height 30px
      align-items center
      .input_null
        display: block
        width: 250px
        height: 45px
        // position: fixed
        right:0;
        top:0;
        background: rgba(0,0,0,0);
        font-size 14px
        // padding 6px 115px 6px 0px
      input
        border none
        outline none
        background rgb(245, 245, 245)
      .search-icon
        background url('../../assets/searchf5.png')
        background-size cover
        width 20px
        height 20px
        display block
        margin 0 4px 0 12px
      .close-icon
        background url('../../assets/closeicon.png')
        background-size cover
        width 18px
        height 18px
        display block
        margin 0 4px 0 12px
        position absolute
        right 5px
</style>
